// ============================================================================
// PALETA DE COLORES SODASIST
// ============================================================================
// Paleta de colores unificada basada en el dashboard principal

export const COLORS = {
  // Colores principales
  primary: {
    50: 'bg-primary-50 dark:bg-primary-900/20',
    100: 'bg-primary-100 dark:bg-primary-900/30',
    200: 'bg-primary-200 dark:bg-primary-800',
    500: 'bg-primary-500',
    600: 'bg-primary-600',
    700: 'bg-primary-700 dark:bg-primary-300',
    800: 'bg-primary-800 dark:bg-primary-200',
    900: 'bg-primary-900 dark:bg-primary-100'
  },
  
  // Colores de texto
  text: {
    primary: 'text-primary-600 dark:text-primary-400',
    secondary: 'text-primary-700 dark:text-primary-300',
    muted: 'text-gray-600 dark:text-gray-400',
    dark: 'text-gray-900 dark:text-white',
    light: 'text-gray-500 dark:text-gray-500'
  },

  // Colores de estado
  success: {
    bg: 'bg-gradient-to-br from-green-50 to-green-100 dark:from-green-900/20 dark:to-green-800/20',
    text: 'text-green-700 dark:text-green-300',
    icon: 'text-green-600 dark:text-green-400',
    border: 'border-green-200 dark:border-green-800',
    iconBg: 'bg-green-500'
  },
  
  warning: {
    bg: 'bg-gradient-to-br from-yellow-50 to-yellow-100 dark:from-yellow-900/20 dark:to-yellow-800/20',
    text: 'text-yellow-700 dark:text-yellow-300',
    icon: 'text-yellow-600 dark:text-yellow-400',
    border: 'border-yellow-200 dark:border-yellow-800',
    iconBg: 'bg-yellow-500'
  },
  
  error: {
    bg: 'bg-gradient-to-br from-red-50 to-red-100 dark:from-red-900/20 dark:to-red-800/20',
    text: 'text-red-700 dark:text-red-300',
    icon: 'text-red-600 dark:text-red-400',
    border: 'border-red-200 dark:border-red-800',
    iconBg: 'bg-red-500'
  },

  info: {
    bg: 'bg-gradient-to-br from-primary-50 to-primary-100 dark:from-primary-900/20 dark:to-primary-800/20',
    text: 'text-primary-700 dark:text-primary-300',
    icon: 'text-primary-600 dark:text-primary-400',
    border: 'border-primary-200 dark:border-primary-800',
    iconBg: 'bg-primary-500'
  },

  // Colores de métricas
  metrics: {
    blue: {
      bg: 'bg-gradient-to-br from-primary-50 to-primary-100 dark:from-primary-900/20 dark:to-primary-800/20',
      text: 'text-primary-700 dark:text-primary-300',
      icon: 'text-primary-600 dark:text-primary-400',
      border: 'border-primary-200 dark:border-primary-800',
      iconBg: 'bg-primary-500'
    },
    green: {
      bg: 'bg-gradient-to-br from-green-50 to-green-100 dark:from-green-900/20 dark:to-green-800/20',
      text: 'text-green-700 dark:text-green-300',
      icon: 'text-green-600 dark:text-green-400',
      border: 'border-green-200 dark:border-green-800',
      iconBg: 'bg-green-500'
    },
    purple: {
      bg: 'bg-gradient-to-br from-purple-50 to-purple-100 dark:from-purple-900/20 dark:to-purple-800/20',
      text: 'text-purple-700 dark:text-purple-300',
      icon: 'text-purple-600 dark:text-purple-400',
      border: 'border-purple-200 dark:border-purple-800',
      iconBg: 'bg-purple-500'
    },
    orange: {
      bg: 'bg-gradient-to-br from-orange-50 to-orange-100 dark:from-orange-900/20 dark:to-orange-800/20',
      text: 'text-orange-700 dark:text-orange-300',
      icon: 'text-orange-600 dark:text-orange-400',
      border: 'border-orange-200 dark:border-orange-800',
      iconBg: 'bg-orange-500'
    }
  },

  // Colores de fondo
  background: {
    primary: 'bg-white dark:bg-gray-800',
    secondary: 'bg-gray-50 dark:bg-gray-900',
    card: 'bg-white dark:bg-gray-800',
    overlay: 'bg-black bg-opacity-50'
  },

  // Colores de borde
  border: {
    primary: 'border-gray-200 dark:border-gray-700',
    secondary: 'border-gray-300 dark:border-gray-600',
    accent: 'border-primary-200 dark:border-primary-800'
  }
} as const;

// ============================================================================
// CLASES DE COMPONENTES COMUNES
// ============================================================================

export const COMPONENT_CLASSES = {
  // Cards
  card: 'bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700',
  cardHover: 'hover:shadow-md transition-all duration-200',
  
  // Botones
  button: {
    primary: 'bg-primary-800 hover:bg-primary-700 active:bg-primary-900 text-white',
    secondary: 'bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200',
    outline: 'border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300'
  },
  
  // Inputs
  input: 'bg-gray-100 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:ring-2 focus:ring-primary-500 focus:border-transparent',
  
  // Navegación
  nav: {
    active: 'bg-primary-100 dark:bg-primary-900/20 text-primary-600 dark:text-primary-400 scale-105',
    inactive: 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-600 hover:scale-105'
  },
  
  // Estados de carga
  loading: 'animate-pulse',
  spinner: 'animate-spin'
} as const;

// ============================================================================
// FUNCIONES AUXILIARES
// ============================================================================

export const getMetricColor = (color: 'blue' | 'green' | 'purple' | 'orange' | 'red' | 'yellow') => {
  if (color === 'red' || color === 'yellow') {
    return COLORS.metrics.blue;
  }
  return COLORS.metrics[color];
};

export const getStatusColor = (status: 'success' | 'warning' | 'error' | 'info') => {
  return COLORS[status] || COLORS.info;
};

export const combineClasses = (...classes: (string | undefined | null | false)[]): string => {
  return classes.filter(Boolean).join(' ');
};
